import React, { useEffect, useMemo, useState } from 'react'
import { Grid } from '@material-ui/core'
import { Button, DatePicker, Loader, Modal } from '@refera/ui-web'
import moment from 'moment'
import useStyles from '../styles'

export default function ChangeDueDateModal({ open, close, onConfirm, isLoading }) {
  const styles = useStyles()
  const [dueDate, setDueDate] = useState(null)

  const isSubmitDisabled = useMemo(() => {
    return !moment(dueDate).isValid() || isLoading
  }, [dueDate, isLoading])

  useEffect(() => {
    if (open) {
      setDueDate(null)
    }
  }, [open])

  return (
    <>
      <Loader hasBackdrop open={isLoading} />
      <Modal
        className={styles.modal}
        title="Alterar vencimento"
        onBackdropClick={close}
        onClose={close}
        open={open}
        actionsButtons={
          <Grid className={styles.modalButtons}>
            <Button color="red" variant="secondary" onClick={close}>
              Cancelar
            </Button>
            <Button
              disabled={isSubmitDisabled}
              color="primary"
              variant="primary"
              onClick={() => onConfirm({ dueDate })}
            >
              Salvar
            </Button>
          </Grid>
        }
      >
        <Grid className={styles.wrapper}>
          <DatePicker
            required
            label="Nova data de vencimento"
            variant="inline"
            value={dueDate}
            defaultValue={dueDate}
            onChange={setDueDate}
            format="dd/MM/yyyy"
            placeholder="DD/MM/AAAA"
            invalidDateMessage="Insira uma data válida"
            className={styles.datePicker}
            refuse={/[^\d\\.]+/gi}
            mask="__/__/____"
          />
        </Grid>
      </Modal>
    </>
  )
}
